$(function(){
  $(document).on('click', '.mobileMenuContainer a[href^="#"]', function(e) {
    // prevent standard hash navigation (avoid blinking in IE)
    e.preventDefault();
        $('.headerInner .buttonWrapper img').click();
 
    // target element id
    var id = $(this).attr('href');
  var parts = window.location.href.split('/');
    var part1_url=parts.pop();
	var part2_url=parts[parts.length - 1];
   
if(part1_url.indexOf('#') != -1 || part1_url ==''){

    // target element
    var $id = $(id);
    if ($id.length === 0) {
        return;
    }

    

    // top position relative to the document
    var pos = $id.offset().top - 100;

    // animated top scrolling
    $('body, html').animate({scrollTop: pos});
}else{
  location.href='https://'+window.location.hostname+'/'+id;
}
});

  if($('#programs_header').length){
   var mobileMenuContainer = document.getElementsByClassName("mobileMenuContainer")[0];
  var programs_header = document.getElementById("programs_header");
  mobileMenuContainer.append(programs_header);
  }

  if($('#retreat_programs_header').length){
   var mobileMenuContainer = document.getElementsByClassName("mobileMenuContainer")[0];
  var retreat_programs_header = document.getElementById("retreat_programs_header");
  mobileMenuContainer.append(retreat_programs_header);
  }

  if($('html').hasClass('no-touch')){
    $('section.retreat-program-block .container .programs .program div.title a').on('mouseenter', function(){
      var pw = $(this).parent().width();
      var tw = $(this).children('.program-title').width();
      var df = pw - tw;
      if(df > 370){
        $(this).children('.popup').css({right: df - 380});
      }else{
        $(this).children('.popup').css({right: '20px'});
      }
    });
  }

  $('section.retreat-program-block .container .programs .program div.title a').on('click', function(e){
    e.preventDefault();
    $('.mobileMenu').addClass('active');
    $('header').addClass('active');
    $('a.nav').addClass('active');
    $('span.ham').addClass('active');
    $('.mobileMenu .mobileMenuContainer .mobileMenuItems').hide();
    $('.mobileMenu .socialLinks').hide();
    $('.mobileMenu .mobileMenuContainer .retreat-programs .program').stop(true, true).removeClass('active').hide();
    $('.mobileMenu .mobileMenuContainer .retreat-programs').stop(true, true).fadeIn(300).addClass('active');
    var thisIndex = $(this).parent().parent().index();
    $('.mobileMenu .mobileMenuContainer .retreat-programs .program').eq(thisIndex).stop(true, true).fadeIn(300).addClass('active');
  });

  $('a.nav').on('click', function(){
    if($(this).hasClass('active')){
      $('.mobileMenu .mobileMenuContainer .retreat-programs').stop(true, true).fadeOut(200).removeClass('active');
      $('.mobileMenu .mobileMenuContainer .retreat-programs .program').stop(true, true).removeClass('active').hide();
    }
  });

});